import React, { useState, useContext } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { AuthContext } from '../App';
import BrandLogo from './BrandLogo';
import { Eye, EyeOff, LogIn, Shield } from 'lucide-react';

const Login = () => {
  const [email, setEmail] = useState('');
  const { tt } = useLanguage();
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { login } = useContext(AuthContext);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const result = await login(email, password);
    if (!result.success) {
      setError(result.error);
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Logo/Header */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center mb-4">
            <BrandLogo size="xl" />
          </div>
          <p className="text-gray-600">{tt('Войдите в систему управления')}</p>
        </div>

        {/* Login Form */}
        <div className="card p-8">
          <form onSubmit={handleSubmit} className="space-y-6">
            {error && (
              <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm" data-testid="login-error">
                {error}
              </div>
            )}

            <div className="form-group">
              <label htmlFor="email" className="form-label">
                <span style={{display:'inline-flex',alignItems:'center',gap:6}}>
                  <span role="img" aria-hidden>📧</span>
                  {tt('Email')}
                  <span style={{color:'#6b7280',fontWeight:400}}>{tt('или')}</span>
                  <span role="img" aria-hidden>📱</span>
                  {tt('Номер телефона')}
                </span>
              </label>
              <input
                id="email"
                type="text"
                inputMode="text"
                autoComplete="username"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="form-input"
                placeholder={tt('admin@forex.com  или  +71234567890')}
                required
                data-testid="email-input"
              />
              <div style={{fontSize:11,color:'#6b7280',marginTop:4,lineHeight:1.4}}>
                {tt('Можно входить по email или номеру телефона (с кодом страны, например +7…)')}
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="password" className="form-label">
                {tt('Пароль')}
              </label>
              <div className="relative">
                <input
                  id="password"
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="form-input pr-12"
                  placeholder={tt('Введите пароль')}
                  required
                  data-testid="password-input"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
                  data-testid="toggle-password"
                >
                  {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                </button>
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="btn btn-primary w-full py-3 text-base font-semibold"
              data-testid="login-button"
            >
              {loading ? (
                <div className="spinner mr-2"></div>
              ) : (
                <LogIn className="w-5 h-5 mr-2" />
              )}
              {loading ? tt('Вход...') : tt('Войти')}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;